import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

// Split CTA band: navy "Get Help" / off-white "Refer or Support"
export const CTABand = () => (
  <section className="grid grid-cols-1 md:grid-cols-2" data-testid="cta-band">
    <div className="bg-navy text-offwhite p-10 md:p-16 lg:p-20">
      <Reveal>
        <div className="label-caps text-gold mb-5">For veterans</div>
        <h3 className="font-heading text-3xl md:text-4xl font-black leading-[1.1]">I need help</h3>
        <p className="mt-4 max-w-md text-offwhite/75 leading-relaxed">
          If you're a veteran facing homelessness or crisis, reach out. The first step is a conversation — no pressure, no judgment.
        </p>
        <Link to="/admissions" data-testid="ctaband-gethelp" className="group mt-8 inline-flex items-center gap-2 bg-offwhite text-navy px-7 py-4 rounded-sm text-sm font-semibold hover:bg-white transition-colors">
          Start intake <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
    <div className="bg-offwhite text-charcoal p-10 md:p-16 lg:p-20 border-t md:border-t-0 md:border-l border-softgray">
      <Reveal delay={0.1}>
        <div className="label-caps text-navy mb-5">For partners & supporters</div>
        <h3 className="font-heading text-3xl md:text-4xl font-black text-navy leading-[1.1]">I want to refer or support</h3>
        <p className="mt-4 max-w-md text-charcoal/75 leading-relaxed">
          Case managers, agencies, donors, and volunteers — help us reach the veterans who need this most.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/partners" data-testid="ctaband-refer" className="group inline-flex items-center gap-2 bg-navy text-offwhite px-7 py-4 rounded-sm text-sm font-semibold hover:bg-navy-deep transition-colors">
            Refer a veteran <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
          <Link to="/donate" data-testid="ctaband-donate" className="inline-flex items-center gap-2 border border-navy text-navy px-7 py-4 rounded-sm text-sm font-semibold hover:bg-navy hover:text-offwhite transition-colors">
            Donate
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTABand;
